export const getChooseAdsPanelStyles = (_, { palette = {} }) => ({
  smartShoppingWarning: {
    padding: '17px 27px',
    '& h3': {
      marginTop: 0,
    },
  },
  dealFilterBar: {
    display: 'flex',
    justifyContent: 'space-between',
    '& .targetFilters': {
      justifyContent: 'space-between',
      display: 'flex',
      width: '250px',

      '& .target': {
        cursor: 'pointer',
        borderRadius: '5px',
        border: '1px solid lightgray',
        padding: '6px',
      },
      '& .target-active': {
        border: '1px solid #0078D4',
        color: '#0078D4',
      },
    },
  },
  smartShoppingWarningLink: {
    display: 'block',
  },
  chooseAdsPanelBody: {
    display: 'flex',
    marginTop: 75,
    marginBottom: 'auto',
    marginRight: 45,
    marginLeft: 45,
    flexWrap: 'wrap',
    padding: 1,
    overflowY: 'auto',
  },
  chooseAdsPanelFooter: {
    height: 64,
    backgroundColor: palette.white,
    marginBottom: 0,
    paddingTop: 16,
  },
  nextButton: {
    marginRight: 8,
  },
  cancelButton: {
  },
  chooseObjectivePanel: {
    boxShadow: 'none',
    '&.MediaPackageCampaign': {
      fontSize: 12,
      '& .campaign-objective-button': {
        boxShadow: '0px 1.6px 3.6px rgba(0, 0, 0, 0.132), 0px 0.3px 0px rgba(0, 0, 0, 0.108)',
        width: 306,
        marginRight: 10,
        marginBottom: 10,
        height: 280,
      },
      '& .deal-description': {
        '& div': {
          lineHeight: 2,
        },
      },
      '& .description-row': {
        height: 'unset',
        textAlign: 'left',
      },
      '& .title-row': {
        textAlign: 'left',
        fontSize: 15,
      },
    },
    '&:focus': {
      outline: 'none',
    },
    '& .panel-close': {
      width: 32,
      height: 44,
      right: 8,
      top: 2,
      minWidth: 'unset',
      '& .panel-cancel-icon': {
        fontSize: 12,
        lineHeight: '12px',
        color: palette.neutralSecondary,
        margin: 0,
        top: 0,
        right: 5,
      },
    },
    '& .panel-title': {
      lineHeight: '27px',
      fontSize: 20,
      color: palette.neutralPrimary,
      fontWeight: 'bold',
    },
    '& .panel-body': {
      paddingBottom: 0,
      display: 'flex',
      flexDirection: 'column',
      position: 'relative',
    },
    '& .panel-header': {
      marginTop: 11,
    },
    '& .ms-MessageBar': {
      backgroundColor: '#EFF6FC',
    },
  },
});
